export default __webpack_public_path__ + "static/media/soapstone.8407bc8e.jpg";